<div class="login-container">
  <mat-card class="login-card">
    <div class="header">
      <h2>Log In</h2>
      <p>Please enter your credentials to access your account</p>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
      <!-- Username or Email -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Username or Email</mat-label>
        <input matInput formControlName="identifier" required>
        <mat-error *ngIf="loginForm.get('identifier').invalid">
          {{ getErrorMessage('identifier') }}
        </mat-error>
      </mat-form-field>

      <!-- Password -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Password</mat-label>
        <input matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'" required>
        <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword" type="button">
          <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error *ngIf="loginForm.get('password').invalid">
          {{ getErrorMessage('password') }}
        </mat-error>
      </mat-form-field>

      <div class="forgot-password">
        <a (click)="navigateToForgotPassword()">Forgot Password?</a>
      </div>

      <button mat-raised-button color="primary" class="submit-button" type="submit" [disabled]="loginForm.invalid || loading">
        <mat-spinner diameter="20" *ngIf="loading"></mat-spinner>
        <span *ngIf="!loading">Log In</span>
      </button>

      <div class="register-link">
        Don't have an account? <a (click)="navigateToRegister()">Register</a>
      </div>
    </form>
  </mat-card>
</div> 